export default __webpack_public_path__ + "static/media/LVZ WEB ICONS - SPEECH TO TRANSLATIONS.088d03ca.svg";